<template>
    <div class="card">

        <header class="card-header has-background-light">
            <p class="card-header-title">FILTERS</p>
            <div class="buttons">
                <b-button size="is-small" @click="isCreate=true">CREATE</b-button>
            </div>
        </header>

        <div class="card-content scrollable" :style="{ height: `${scrollableHeight}px` }">

            <!--
            <b-field label="Status">
                <b-select v-model="filters.status" expanded>
                    <option value>ALL</option>
                    <option :value="1">ACTIVE</option>
                    <option :value="0">INACTIVE</option>
                </b-select>
            </b-field>
            -->

            <base-select
                :service="$options.codeService"
                fetch-func="all"
                :fetch-params="{
                    contract_id: contractId || undefined,
                    firm_id: $store.state.Auth.user.firmId,
                    type: 'orderPriority'
                }"
                label="Priority"
                :value.sync="filters.priority"
            >
                <template #defaultOptionLabel>All Priorities</template>
            </base-select>

            <!-- <base-select
                :service="$options.firmService"
                fetch-func="all"
                label="Firm"
                :value.sync="filters.firm"
                value-key="id"
                label-key="name"
            >
                <template #defaultOptionLabel>All Firms</template>
            </base-select> -->
            
            <b-field label="Include Archived"></b-field>
            <b-field>
                <b-switch v-model="filters.includeArchived" type="is-success"/>
            </b-field>

            <!--
            <b-field label="Is Urban?"></b-field>
            <div class="block">
                <b-radio v-model="filters.isUrban" :native-value="null">N/A</b-radio>
                <b-radio v-model="filters.isUrban" :native-value="1">Yes</b-radio>
                <b-radio v-model="filters.isUrban" :native-value="0">No</b-radio>
            </div>
            -->

        </div>

        <footer class="card-footer" ref="footer">
            <div class="columns">
                <div class="column is-half"><b-button class="is-fullwidth is-large is-default" @click="reset">RESET</b-button></div>
                <div class="column is-half"><b-button class="is-fullwidth is-large is-info" @click="filter">FILTER</b-button></div>
            </div>
        </footer>

        <!-- Clone Role -->
        <b-modal :active.sync="isCreate" trap-focus aria-role="dialog" aria-modal>
            <createServiceLevelModal
                :organization="organization"
                :contract-id="contractId"
                @create="() => $emit('create')"
            />
        </b-modal>

    </div>
</template>

<script>

    import BaseSelect from "@/components/partials/BaseSelect";
    import { FirmService } from "@/services/firm.service";
    import { OrderService } from "@/services/order.service";
    import { CodeService } from "@/services/code.service";
    import createServiceLevelModal from "./createServiceLevelModal";

    export default {

        firmService: FirmService,
        orderService: OrderService,
        codeService: CodeService,
        props: {
            organization: {
                type: Object
            },
            contractId: {
                type: [String, Number],
            },
            height: {
                type: Number,
                default: 500
            }
        },
        components: {
            BaseSelect,
            createServiceLevelModal
        },
        data: () => ({
            filters: {
                firm: "",
                status: "",
                priority: "",
                isUrban: null,
                includeArchived: false
            },
            isCreate: false
        }),
        computed: {
            scrollableHeight() {
                const spacesOnTop = 44 + 100; // Card Header, Card content top/bot padding, Card Footer
                return this.height - spacesOnTop;
            }
        },
        methods: {
            filter() {
                this.$emit("filter", JSON.parse(JSON.stringify(this.filters)));
            },
            reset() {
                this.filters = {
                    firm: "",
                    status: "",
                    priority: "",
                    isUrban: null,
                    includeArchived: false
                };
                this.filter();
            }
        }

    };

</script>


// WEBPACK FOOTER //
// src/components/pages/ServiceLevels/list/partials/filters.vue